import { Link } from "react-router-dom";
import ArticleCard from "@/components/base/ArticleCard";
import { articles } from "@/mocks/articles";

export default function ArticleSection() {
  const featured = articles[0];
  const rest = articles.slice(1, 4);

  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="font-heading text-sm text-primary-600">番剧资讯</span>
            <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">追番资讯 · 深度盘点</h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600 md:text-base">
              新番导览、国漫盘点与追番攻略，为你的动漫之旅提供灵感。
            </p>
          </div>
          <Link
            to="/articles"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-full border border-background-300 px-5 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
          >
            查看全部资讯
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-2">
          <ArticleCard article={featured} />
          <div className="flex flex-col gap-6">
            {rest.map((article) => (
              <ArticleCard key={article.id} article={article} horizontal />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}